export default __webpack_public_path__ + "media/images/icons/house-d10ebbca419a79ec474310ef658fe0e9.svg";